module.exports = __webpack_public_path__ + "static/img/iconPicture.1d177bd.png";